<span
    [ngClass]="{ 'in-stock': status === 'InStock', 'few': status === 'Few', 'no-stock': status === 'NoStock' }"
></span>
